/**
 * Network quality tracker: OFFLINE / SLOW / GOOD.
 * Fed by api.ts response timings (EMA of request duration) and browser online/offline events.
 */
export type NetworkQuality = 'OFFLINE' | 'SLOW' | 'GOOD';

// ponytail: fixed threshold; make it adaptive if cashiers on 3G complain about a permanent "slow" dot
const SLOW_MS = 2000;
const ALPHA = 0.3;

let ema: number | null = null;
let lastFailed = false;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((l) => l());

export function recordLatency(ms: number) {
    ema = ema === null ? ms : ALPHA * ms + (1 - ALPHA) * ema;
    lastFailed = false;
    notify();
}

export function recordNetworkFailure() {
    lastFailed = true;
    notify();
}

export function getNetworkQuality(): NetworkQuality {
    if (typeof navigator !== 'undefined' && !navigator.onLine) return 'OFFLINE';
    if (lastFailed) return 'OFFLINE';
    if (ema !== null && ema > SLOW_MS) return 'SLOW';
    return 'GOOD';
}

export function subscribeNetworkQuality(cb: () => void) {
    listeners.add(cb);
    window.addEventListener('online', cb);
    window.addEventListener('offline', cb);
    return () => {
        listeners.delete(cb);
        window.removeEventListener('online', cb);
        window.removeEventListener('offline', cb);
    };
}
